<template><div>

	<div class="content-preload" v-if="filteredItems==undefined">
		<div class="spinner"></div>
	</div>

	<div class="view specs" v-if="filteredItems!=undefined">

		<box :label="filteredItems.length+' specs'">

			<template slot="meta-r">
				<div class="textlink" v-if="false" @click="createNewSpec()">Nyt spec</div>
			</template>

			<div class="grid">
				<div class="col m25">

					<inputfield label="Kunde">
						<select id="status-select" :value="status_filter" ref="status_filter" v-on:change="status_filter_updated">
							<option value="all">Alle</option>
							<option :value="client_key" v-for="(client,client_key,client_i) in clients">{{client.name}}</option>
						</select>
						<div class="select-arrow">▾</div>
					</inputfield>

				</div>
				<div class="col m25">

					<inputfield label="Opgave">
						<select id="status-select" :value="status_filter" ref="status_filter" v-on:change="status_filter_updated">
							<option value="all">Alle</option>
							<option :value="project_key" v-for="(project,project_key,project_i) in projects">{{project.name}}</option>
						</select>
						<div class="select-arrow">▾</div>
					</inputfield>

				</div>
				<div class="col m25">

					<inputfield label="Status">
						<select id="status-select" :value="status_filter" ref="status_filter" v-on:change="status_filter_updated">
							<option value="all">Alle</option>
							<option :value="status_key" v-for="(status,status_key,status_i) in $store.state.specs.statuses">{{status.title}}</option>
						</select>
						<div class="select-arrow">▾</div>
					</inputfield>

				</div>
				<div class="col m25">
					<inputfield label="Søg">
						<input type="text" placeholder="Søg" :value="search_filter" ref="search_filter" v-on:keyup="search_filter_updated">
					</inputfield>
				</div>				
			</div>

			<br>

			<table class="table-a spec-table" v-if="filteredItems.length">
				<thead>
					<tr>
						<th></th>
						<th>Spec</th>
						<th class="align-l">Opgave</th>
						<th class="align-l">Kunde</th>
						<th class="align-r hide">Tidsbudget</th>
						<th class="_align-r" v-if="is_admin">Budget</th>
						<th class="align-r" v-if="is_admin">Oprettet</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(spec,i) in filteredItems">
						<td>
							<avatar :input="spec"></avatar>
						</td>
						<td>
							<router-link class="textlink" :to="'/spec/'+spec.key">
								<template v-if="spec.title">{{spec.title}}</template>
								<template v-if="!spec.title">Unavngiven</template>
							</router-link>
						</td>
						<td class="align-l">
							<router-link class="textlink" v-if="getProject(spec)" :to="'/project/'+getProject(spec).key">
								{{getProject(spec).name}}
							</router-link>
						</td>
						<td class="align-l">
							<router-link class="textlink" v-if="getClient(spec)" :to="'/project/'+getClient(spec).key">
								{{getClient(spec).name}}
							</router-link>							
						</td>
						<td class="_align-r" v-if="is_admin">

							{{ specGetBudget(spec) | money(0) }} kr.
						</td>
						<td class="align-r">
							{{spec.created.split(' ')[0]}}
						</td>

					</tr>
				</tbody>
			</table>

		</box>

		<btn @click.native="createNewSpec()" v-if="false">Nyt Spec</btn>

	</div>

</div></template>

<script>
import mixins from '../mixins.js'
import moment from 'moment'
//import fdb from '../firebase_config.js';
import helpers from '../helpers.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Pagination from '.././components/Pagination'
import Datatable from '.././components/Datatable'
import Avatar from '.././components/Avatar'
import Minipctbar from '.././components/Minipctbar'
import Minidonut from '.././components/Minidonut'
import Inputfield from '.././components/Inputfield'
import './../components/generated_svg_icons/ionicons/ios-play'
export default {
	name: 'specs',
	mixins: [ mixins.db, mixins.generic ],
	data: function() {
		return {
			globals: this.$parent.globals,
			specs_currentpage: 1,
			specs_perpage: 25,
			specs_filter: undefined,
		}
	},
	computed: {

		status_filter(){ return globals.specs.status_filter },
		search_filter(){ return globals.specs.search_filter },

		filteredItems(){

			var output = []

			var items = this.$store.state.firebase.specs
			if( !items ) return output
			var filterString = this.search_filter

			if( !filterString || filterString == undefined || filterString == '' ) filterString = undefined
			if(filterString) filterString = filterString.toLowerCase()

			for( var spec_key in items ) {
				//if( !items ) continue
				//if( !items[spec_key] ) continue
				
				var spec = items[spec_key]
				if( spec == 'specs' ) continue
				
				spec['.key'] = spec_key

				if( this.status_filter != 'archived' && spec.archived ) continue

				if( this.status_filter == 'archived' ) {
					if( !spec['archived'] || spec.archived != true ) continue
				}
				
				if( this.status_filter != 'all' ) {
					if( spec.status != this.status_filter ) continue;
				}

				var project = this.$store.state.firebase.projects[spec.project_key]
				if(project) {
					var client = this.$store.state.firebase.clients[project.client_key]
				}

				if( filterString ) {
					var match1 = ( spec.title.toLowerCase().indexOf(filterString) >= 0 )
					if(project) var match2 = ( project.name.toLowerCase().indexOf(filterString) >= 0 )
					if(client) var match3 = ( client.name.toLowerCase().indexOf(filterString) >= 0 )
					if( !project && !match1 ) continue
					if( !client && !(match1||match2) ) continue
					if( !(match1 || match2 || match3) ) continue
				}

				output.push(spec)
			}

			return output

		},

		clients(){ return this.$store.state.firebase.clients },
		projects(){ return this.$store.state.firebase.projects },

	},
	methods: {

		outputMoney: helpers.outputMoney,
		readTimeloggedHours: helpers.readTimeloggedHours,

		search_filter_updated(){
			globals.specs.search_filter = this.$refs.search_filter.value
			globals.specs.status_filter = 'all'
		},

		status_filter_updated(){
			globals.specs.status_filter = this.$refs.status_filter.value
		},

		gotoSpec(spec) {
			this.$router.push('spec/' + spec['.key'])
		},

		goto(url) {
			this.$router.push(url)
		},

		getSpecStatus(spec) {
			if (!spec.status) return
			if (!this.$store.state.specs.statuses) return
			if (!this.$store.state.specs.statuses[spec.status]) return
			if (!this.$store.state.specs.statuses[spec.status].title) return
			return this.$store.state.specs.statuses[spec.status].title
		},

		getSpecType(spec) {
			if (!spec.status) return
			if (!this.$store.state.specs.types) return
			if (!this.$store.state.specs.types[spec.type]) return
			if (!this.$store.state.specs.types[spec.type].title) return
			return this.$store.state.specs.types[spec.type].title
		},

		getProject(spec){
			if(!spec['project_key']) return
			var project = this.$store.state.firebase.projects[spec.project_key]
			if(project) return project
		},

		getClient(spec){
			var project = this.getProject(spec)
			if(!project) return
			var client = this.$store.state.firebase.clients[project.client_key]
			if(client) return client
		},

		getSpecClient(spec) {
			return
			var client = {
				name: undefined
			}
			//if( spec.client_key )
			if (spec.client_key && this.$store.state.firebase.clients && this.$store.state.firebase.clients[spec.client_key]) client = this.$store.state.firebase.clients[spec.client_key]
			return client
		},

		getFilteredItems(items, filterString) {

			if (!filterString || filterString == undefined || filterString == '') return items

			filterString = filterString.toLowerCase()

			//if( typeof items === 'object' ) items = Object.keys(items).map((k) => items[k])

			items = items.filter(function(item) {
				//console.log(item)
				var bool = false
				for (var k in item) {
					var v = item[k]

					if (v.archived) return false
					// if attrs_array defined, and if !in_array attrs_array continue
					//console.log(k)
					//console.log(v)
					if (v.toLowerCase().indexOf(filterString) >= 0) bool = true
				}
				return bool
			})

			items = items.sort(function(a,b){
				return b.project_key > a.project_key
			})

			return items
		},

		specs_filter_updated() {
			this.specs_currentpage = 1
		},

		getPaginatedItems(items) {

			//if( typeof items === 'object' ) items = Object.keys(items).map((k) => items[k])

			var start = this.specs_perpage * (this.specs_currentpage - 1)
			var end = this.specs_perpage * this.specs_currentpage

			items = items.slice(start, end)

			// this.specs_currentpage
			// this.specs_perpage

			//console.log(items)


			return items
		},

		listspecs() {
			var items = []

			for (var i in this.specs) {
				var spec = this.specs[i]
				if (spec.archived) continue
				items.push(spec)
			}

			return items
			//return this.getPaginatedItems(this.getFilteredItems(this.specs,this.specs_filter),this.specs_currentpage,this.specs_perpage)
		},

		paginationUpdate(page) {
			this.specs_currentpage = page
		},
		incrementGlobalCount() {
			//console.log(this.$root)
			//this.$parent.globals.count++
			window.globals.count++
		},

		createNewSpec() {
			eventBus.$emit('spec_create_new')
		},

		specGetBudget(spec){
			var total_hrs = 0
			for( var i in spec.taskcats ) {
				var taskcat = spec.taskcats[i]
				for( var i in taskcat.tasks ) {
					var task = taskcat.tasks[i]
					if( task.optional == false ) continue
					total_hrs += parseFloat(task.hours)
				}
			}
			return spec.hour_rate * total_hrs
		},

	}, //methods

	created() {
		
		if( !this.is_admin ) this.goto('/')

	},

	components: { Box, Btn, Avatar, Datatable, Pagination, Minipctbar, Minidonut, Inputfield },
}
</script>



// WEBPACK FOOTER //
// Specs.vue?02fe43f9